import React, { useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Table } from 'reactstrap';
import { GET_HEARTS } from '../../../query/query';

const Heart = ({ date: dateProp, seen, recipient }) => {
  const [date] = useState(new Date(+dateProp).toLocaleString());
  return (
    <tr>
      <td>
        <ul>
          <li key={recipient}>{recipient}</li>
        </ul>
      </td>
      <td>{seen ? '✅' : '❌'}</td>
      <td>{date}</td>
    </tr>
  );
};

const SAVGetHearts = ({ error, hearts, loading }) => {
  if (loading || error) {
    return (
      <tr>
        <td colSpan="3">
          {loading ? 'loading...' : 'error'}
        </td>
      </tr>
    );
  }
  if (!hearts || !hearts.length) {
    return (
      <tr>
        <td colSpan="3">
          No hearts have been received yet.
        </td>
      </tr>
    );
  }
  return hearts
    .sort(({ date: date1 }, { date: date2 }) => date2 - date1)
    .map(({ _id, recipient, date }) => (
      <Heart
        key={_id}
        recipient={recipient}
        date={date}
      />
    ));
};

const HeartsList = ({ selectedLovebox }) => {
  const {
    data: { savGetHeartsByBox } = {},
    error: heartsError,
    loading: heartsLoading,
  } = useQuery(GET_HEARTS, { variables: { selectedLovebox } });
  return (
    <div>
      <Table hover>
        <thead>
          <tr>
            <th>Recipients</th>
          </tr>
          <tr>
            <th>Emails</th>
            <th>Seen</th>
            <th>Date</th>
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <th />
          </tr>
        </thead>
        <tbody>
          <SAVGetHearts
            error={heartsError}
            hearts={savGetHeartsByBox}
            loading={heartsLoading}
          />
        </tbody>
      </Table>
    </div>
  );
};

export default HeartsList;



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/table/hearts-list.js